(ns hypnos.backoffice.bar.navigation
  "The backOffice main navigation bar."
  (:require [hypnos.backoffice.core.auth :as auth]
            [hypnos.backoffice.events]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Bar

(defn bar
  "The navigation bar"
  []
  (let [auth      (rf/subscribe [:backoffice/auth])
        user      (rf/subscribe [:backoffice/user])
        panel     (rf/subscribe [:backoffice/active-panel])
        aside     (rf/subscribe [:backoffice/aside])
        user-name (str (:user/first-name @user) " " (:user/last-name @user))]
    [:nav#navbar-main.navbar.is-fixed-top
     [:div.navbar-brand
      [:a.navbar-item.is-desktop-icon-only.is-hidden-touch.jb-aside-toggle
       {:title       (tr :ui.label/expand)
        :on-click    (fn [_] (rf/dispatch [:backoffice/toggle-aside]))
        :data-target "aside-main"}
       [:span.icon
        [:i.mdi.mdi-24px
         {:class (if (:expanded? @aside) "mdi-backburger" "mdi-forwardburger")}]]]
      [:a.navbar-item.is-hidden-desktop.jb-aside-mobile-toggle
       {:on-click (fn [_] (rf/dispatch [:backoffice/toggle-aside]))}
       [:span.icon
        [:i.mdi.mdi-24px
         {:class (if (:expanded? @aside) "mdi-backburger" "mdi-forwardburger")}]]]
      ;; main action
      (when (auth/authorized? @auth :create-new-consult)
        (let [disable? (not (contains? #{:dashboard-panel :patients-panel} (:name @panel)))]
          [:div.navbar-item
           [:a.button.is-success.is-small
            {:disabled disable?
             :href     (if disable? "" "/patient")}
            [:span (tr :ui.label/create-consult)]]]))
      (when (auth/authorized? @auth :create-new-consult)
        (let [disable? (not (contains? #{:dashboard-panel :patients-panel} (:name @panel)))]
          [:div.navbar-item
           [:a.button.is-success.is-small
            {:disabled disable?
             :href     (if disable? "" "/referral")}
            [:span (tr :ui.label/refer)]]]))
      ;; search
      #_[:div.navbar-item.no-left-space
         [:div.control
          [:input.input {:placeholder (tr :ui.placeholder/search)}]]]]
     [:div.navbar-brand.is-right
      [:a.navbar-item.is-hidden-desktop.jb-aside-right-toggle
       [:span.icon
        [:i.mdi.mdi-bell.default]]]
      [:a.navbar-item.is-hidden-desktop.jb-navbar-menu-toggle
       {:data-target "navbar-menu"}
       [:span.icon
        [:i.mdi.mdi-dots-vertical]]]]
     [:div#navbar-menu.navbar-menu.fadeIn.animated.faster
      [:div.navbar-end
       [:div.navbar-item.has-divider
        [:p user-name]]
       [:a.navbar-item {:title (tr :ui.label/logout)}
        [:span
         {:on-click (fn [_] (rf/dispatch [:backoffice/logout]))}
         (tr :ui.label/logout)]]]]]))
